import {Component, Input, OnInit} from "@angular/core";
import {ReportType} from "../../../measurement-models";
import {emptyListItem, ReportDownloadAction} from "../list-item.component";
import {ReportFilenameFactory} from "../../report/download/report-filename-factory.service";
import {ListItem} from "../../list-item";
import {AuthenticatedUser} from "../../../authentication/authenticated-user";
import {AuthenticationService} from "../../../authentication/authentication.service";
import {ReleaseToggleState} from "../../../../tools/release-toggles/release-toggle-state";
import {GetSleepReportDataService} from "../../../analize/sleep-report/get-sleep-report-data.service";
import {SleepReportGenerator} from "../../../analize/sleep-report/sleep-report-generator.service";
import {I18nService} from "../../../../i18n/i18n.service";
import {withGeneratedFindings} from "../../../analize/sleep-report/sleep-findings-text";


@Component({
  selector: "app-download-report",
  templateUrl: "./download-report.component.html",
  standalone: false
})
export class DownloadReportComponent implements OnInit {

  @Input() item: ListItem = emptyListItem();

  readonly feature569Released = ReleaseToggleState.getInstance().isReleased("AUTOMATICALLY_GENERATE_SLEEP_REPORT_569");

  private user!: AuthenticatedUser;

  constructor(
    private readonly reportFilenameFactory: ReportFilenameFactory,
    private readonly authenticationService: AuthenticationService,
    private readonly getSleepReportDataService: GetSleepReportDataService,
    private readonly sleepReportGenerator: SleepReportGenerator,
    private readonly i18nService: I18nService
  ) {
  }

  ngOnInit(): void {
    this.user = this.authenticationService.getCurrentAuthenticatedUser()!;
  }

  shouldShow(): boolean {
    if (this.shouldShowGenerateSleepReport()) {
      return false;
    }

    const role = this.user.role;
    const status = this.item.foundMeasurement.status;
    const isChainDoctor = this.user.isChainDoctor;

    switch (role) {
      case "NURSE":
        return status === "DONE";
      case "DATA_OFFICER":
        return status === "DONE" || status === "READY_FOR_POST_ANALYSIS";
      case "DOCTOR":
        return status === "DONE" && isChainDoctor;
      default:
        return false;
    }
  }

  shouldShowGenerateSleepReport(): boolean {
    return this.feature569Released
      && this.item.foundMeasurement.type === "SLEEP"
      && this.user.role === "DATA_OFFICER"
      && this.item.foundMeasurement.status === "READY_FOR_POST_ANALYSIS"
      && !this.item.foundMeasurement.reportExists;
  }

  generateSleepReport(): void {
    this.getSleepReportDataService
      .get(this.item.foundMeasurement.id)
      .subscribe(data => this.sleepReportGenerator.generateAndDownload(
        withGeneratedFindings(data, key => this.i18nService.getLocalizedString(key, data.metadata.reportLanguage))
      ));
  }

  getDownloadUrl(reportDownloadAction: ReportDownloadAction): string {

    const fileName = this.reportFilenameFactory.createFilename(this.item.foundMeasurement, reportDownloadAction);

    const reportType: ReportType = "MEASUREMENT_REPORT";

    // eslint-disable-next-line max-len
    return `/api/measurements/${this.item.foundMeasurement.id}/report/${reportType}/download/${encodeURI(fileName)}?token=${this.user.token}`;
  }

  markReportDownloadedForNurse(): void {
    if (this.user.role === "NURSE") {
      this.item.foundMeasurement = {...this.item.foundMeasurement, nurseDownloadedReport: true};
    }
  }

  showNurseDownloadedReport(): boolean {
    if (this.item.foundMeasurement.nurseDownloadedReport) {
      return false;
    }

    return this.user.role === "NURSE"
      || this.user.role === "DATA_OFFICER";
  }
}

